import type { SwipeDirection } from '../types';


/**
 * Returns the CSS `touch-action` value that preserves native scroll on the
 * perpendicular axis while allowing the swipe gesture.
 *
 * @param direction - The swipe direction.
 * @returns `'pan-y'`, `'pan-x'`, or `'none'`.
 */
export const getCssTouchAction = (direction: SwipeDirection): string => {
    if (direction === 'left' || direction === 'right') {
        return 'pan-y';
    }

    if (direction === 'up' || direction === 'down') {
        return 'pan-x';
    }
    
    return 'none';
}
